// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"239": "__federation_expose_notificationHatchv2","406": "__federation_expose_notificationHatch","55": "__federation_expose_configureNotificationHatch",}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".js"
}